
import React from 'react'
import { mount } from 'enzyme'

import { Guarantor } from '../data/mockStore'

import { QuestionType } from '../../components/QuestionType'
import { GeneralFunctions } from '../../helper'

describe ("Component: QuestionType", () => {
  let wrapper, questionType, instance, props, result

  beforeAll (() => {
    props = {
      section: "business_info",
      step: "basic_info",
      entity: Guarantor,
      question: Guarantor.questions[0],
      answers: Guarantor.answers,
      checkInputValues: () => {
        result = 'checkInputValues'
      },
      updateAnswer: () => {
        result = 'updateAnswer'
      },
      updateAnswerMutation: () => {
        result = 'updateAnswerMutation'
      }
    }
    questionType = mount(<QuestionType {...props}/>)
    instance = questionType.instance()
  })

  describe('#questionTitle', () => {
    it('should return number', () => {
      const { questionTitle } = instance

      expect(typeof questionTitle).toBe('string')
      expect(questionTitle).toBe("How many years have you worked in this industry?")
    })
  })

  describe('#titlePerQuestion', () => {
    describe('when no number', () => {
      it('should return nil', () => {
        const title = instance.titlePerQuestion()

        expect(title).toBeFalsy()
      })
    })

    describe('when number', () => {
      it('should return tile', () => {
        const title = instance.titlePerQuestion(1102)

        expect(typeof title).toBe('string')
        expect(title).toBe("Revenue in  2019")
      })
    })
  })

  describe('#renderChildQuestions', () => {
    describe('when no questions', () => {
      it('should return null', () => {
        const obj = instance.renderChildQuestions([], {})

        expect(obj).toBeFalsy()
      })
    })

    describe('when questions', () => {
      it('should return obj', () => {
        const obj = instance.renderChildQuestions([{ rid: 1 }], {})

        expect(typeof obj).toBe('object')
        expect(obj).toBeTruthy()
      })
    })
  })

  describe('#messageErrorBoolean', () => {
    it('when question is default', () => {
      const message = instance.messageErrorBoolean('true', 'Yes')

      expect(message).toContain('This answer must be a')
    })

    it('when question 800, 900, 901, 1000', () => {
      props.question.number = 900
      questionType.setProps({ question: props.question })

      const message = instance.messageErrorBoolean('true', 'Yes')

      expect(message).toContain('the loan will not be approved.')
    })
  })

  it ("Render with QuestionType form ", () => {
    wrapper = questionType.find("DefaultInput")
    expect(wrapper.length).toBe(1)
  })
  it ("Render with QuestionType form with text answer", () => {
    props.question.format = "Answer::Text"
    questionType.setProps({ question: props.question })
    wrapper = questionType.find("DefaultTextArea")

    expect(wrapper.length).toBe(1)
  })
  it ("Render with QuestionType form with String answer", () => {
    props.question.format = "Answer::String"
    questionType.setProps({question: props.question})
    wrapper = questionType.find("DefaultInput")

    expect(wrapper.length).toBe(1)
  })
  it ("Render with QuestionType form with Decimal answer", () => {
    props.question.format = "Answer::Decimal"
    questionType.setProps({question: props.question})
    wrapper = questionType.find("DefaultInput")

    expect(wrapper.length).toBe(1)
  })
  it ("Render with QuestionType form with Date answer", () => {
    props.question.format = "Answer::Date"
    questionType.setProps({question: props.question})
    wrapper = questionType.find("DefaultInput")

    expect(wrapper.length).toBe(1)
  })
  describe ("Events and functions:", () => {
    QuestionType.prototype.componentWillReceiveProps = jest.fn(QuestionType.prototype.componentWillReceiveProps)
    it('onToggleDetails', () => {
      instance.onToggleDetails()
      expect(instance.state.showModal).toBeTruthy()
      instance.onToggleDetails()

      expect(instance.state.showModal).toBeFalsy()
    })
    it('checkInputValues', () => {
      instance.checkInputValues()

      expect(result).toBe('checkInputValues')
    })
    it ("removeErrorOnBlur",() => {
      let event = {target: {id: "textarea"}}
      instance.removeErrorOnBlur(event)

      expect(instance.state.validations.textarea).toBe(false)
    })
    it ("validateToSendData valid true: update answer",() => {
      let event = {target:{
          id: "count",
          value: "test"
        }
      }
      instance.validateToSendData(event, true)

      expect(instance.state.answered).toBeTruthy()
    })
    it ("validateToSendData valid true : AnswerMutation",() => {
      let event = {target:{
          id: "count",
          value: "test"
        }
      }
      props.answers = []
      questionType.setProps({answers: props.answers})
      instance.validateToSendData(event,true)
      expect(instance.state.answered).toBeTruthy()
    })
    it ("validateToSendData valid false",() => {
      let event = {target:{
          id: "count",
          value: "test"
        }
      }
      instance.validateToSendData(event,false)

      expect(instance.state.validations.count).toBeTruthy()
    })
  })

  describe('#onKeyup', () => {
    let removeErrorOnBlur
    beforeEach(() => {
      removeErrorOnBlur = spyOn(instance, 'removeErrorOnBlur')
    })

    it('when question has not question to answer', () => {
      instance.onKeyup({ target: { value: '111'}})

      expect(removeErrorOnBlur).toHaveBeenCalled()
    })
  })

  describe('#finalValue', () => {
    it('when question is not currency', () => {
      const value = instance.finalValue(100000)
      expect(value).toBe(100000)
    })

    it('when question is currency', () => {
      props.question.number = 700
      questionType.setProps({...props, question: props.question})

      const callFunc = spyOn(GeneralFunctions, 'cleanNumberCurrency')
      instance.finalValue('$100,000')

      expect(callFunc).toHaveBeenCalled()
    })
  })

  describe('#runAnsweredQuestion', () => {
    it('should run func', () => {
      const actionFunction = () => {
        result = 'actionFunction'
      }
      const runMutationAnswer = spyOn(instance, 'runMutationAnswer')
      instance.runAnsweredQuestion(actionFunction, 100000)

      expect(runMutationAnswer).toHaveBeenCalled()
      expect(instance.state.isShouldAnswered).toBeFalsy()
      expect(result).toBe('actionFunction')
    })
  })

  describe('#removeErrorOnBlur', () => {
    let checkInputValues
    beforeEach(() => {
      checkInputValues = spyOn(instance, 'checkInputValues')
    })
    describe('when has no questions', () => {
      it('should run func', () => {
        instance.removeErrorOnBlur({ target: { id: 1 }})

        expect(checkInputValues).toHaveBeenCalled()
      })
    })

    describe('when has questions', () => {
      describe('when savedAnswer less than 3', () => {
        it('should run func', () => {
          instance.state.savedAnswer = 10
          instance.removeErrorOnBlur({ target: { id: 1 }})

          expect(checkInputValues).toHaveBeenCalled()
        })
      })

      describe('when savedAnswer more than 3', () => {
        it('should run func', () => {
          instance.state.savedAnswer = 1000
          instance.removeErrorOnBlur({ target: { id: 1 }})

          expect(checkInputValues).toHaveBeenCalled()
        })
      })
    })
  })

  describe ("Render with QuestionType form with Boolean answer", () => {
    beforeAll( () => {
      props.question = Guarantor.questions[2]
      props.question.children = Guarantor.questions
      questionType = mount(<QuestionType {...props}/>)
    })
    it ("componentWillMount", () => {
      wrapper = questionType.find("ChipSelector")
      expect(wrapper.length).toBe(2)
    })
    it ("Select first option: update answer", () => {
      const option = instance.state.boolean[0]
      const func = () =>{
        option['active'] = true
      }
      wrapper.first().simulate("change", func())
      expect(option.active).toBeTruthy()

    })
    it ("Select first option ", () => {
      props.answers = []
      questionType.setProps({answers: props.answers})
      wrapper.first().simulate("click")
      expect(instance.state.showError).toBeFalsy()
    })
  })

  describe('#returnQuestionFormat', () => {
    describe('when format is Array', () => {
      beforeAll(() => {
        props.question.format = "Answer::Array"
        props.question.children = []
        questionType.setProps({ question: props.question })
        instance = questionType.instance()
      })

      it("should return component", () => {
        const obj = instance.returnQuestionFormat()

        expect(obj).toBeTruthy()
        expect(JSON.stringify(obj)).toContain('multiselect')
        expect(typeof obj).toBe('object')
      })
    })
  })

  describe("#placeholderMultiselect", () => {
    it("should return text", () => {
      const string = instance.placeholderMultiselect()

      expect(string).toBe('Search for option')
    })
  })

  describe('#resolveOutput', () => {
    let runMutationAnswer, checkInputValues
    beforeEach(() => {
      runMutationAnswer = spyOn(instance, 'runMutationAnswer')
      checkInputValues = spyOn(instance, 'checkInputValues')
      instance.setState({ answered: false })
    })

    it('should call functions and set value', () => {
      instance.resolveOutput(['Jamaica'])

      expect(runMutationAnswer).toHaveBeenCalled()
      expect(checkInputValues).toHaveBeenCalled()
      expect(instance.state.answered).toBeTruthy()
    })
  })

})
